<template>
	<div class="set_face">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置人脸识别阈值</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据需求设置人脸识别阈值，值越大识别越严格，建议使用默认值（不设置即可）。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (BOOL)skFaceSetFaceThreshold:(int)threshold;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）threshold：阈值，50-100，int类型</p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">BOO类型，true设置成功，false设置失败</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">[SKFaceManagerInterface skFaceSetFaceThreshold:80];</code></pre>
		<pre class="doc_main_pre"><code class="doc_main_code">//SDK使用示例代码
//1.初始化SDK
__block BOOL isCallBackSucceed = false;
BOOL isSucceed = [SKFaceManagerInterface skFaceInitSDKWithApiKey:
@"xxxxx" apiSecret:@"xxxxx" sdkInitCallback:^(int code, NSString *msg) 
{
	if (code == 0) {
					isCallBackSucceed = true;
					//2.视频人脸检测与跟踪初始化
					BOOL result = [SKFaceManagerInterface skFaceVideoTrackInitWithWidth:720 height:1280
					model:1 strangerShortMemory:NO];
       				 }
}];
//3.在摄像头帧数据里调用视频人脸检测与跟踪，需SDK初始化返回true并且SDK初始化回调值code=0时才可使用
if (isSucceed && isCallBackSucceed) {
   [SKFaceManagerInterface skFaceVideoTrack:pBGR24 faceDetectCallback:
         ^(struct FaceStruct *faceStruct, int retCount) 
	    {
			//这里对回调数据进行处理
			//这样就可以取到当前视频帧中的第一个人脸的检测数据
			FaceStruct firstFaceStruct = faceStruct[0];
    	   }
   ];
}
//4.释放SDK与资源（不使用时）
[SKFaceManagerInterface skFaceReleaseSDK];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','基础接口','设置人脸识别阈值'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.set_face{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/basics/setFace.vue